"use strict";

exports.__esModule = true;
exports.FlexPassthrough = FlexPassthrough;
var _excluded = ["children"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Helper component which passes the props it receives to a render prop.
 * @component
 */
function FlexPassthrough(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return children(props);
}